<template>
  <div
    v-if="size > 1"
    class="c-section-indicator u-desktop-only"
  >
    <div
      v-for="i in size"
      :class="{ 'is-highlighted': i === highlighted }"
      class="c-section-indicator__bulb"
    ></div>
  </div>
</template>
<script>
  export default {
    props: {
      current: Number,
      total: Number,
      perPage: Number,
    },
    computed: {
      size() {
        return Math.ceil(this.total / this.perPage);
      },
      highlighted() {
        return Math.ceil((this.current + this.perPage) / this.perPage);
      },
    },
  };
</script>
